import { http } from '@/core/api/';
import { tapRequestQuestionnaireTypes } from './_types';

export const getORERecommendations = async (sectionId) => {
  try {
    if (!sectionId) return;
    const questionnaireType =
      tapRequestQuestionnaireTypes.SolicitudAsistenciaTecnicaUbicaciónEstudiante;
    const { data } = await http.get(
      `/api/questionnaire/questions/${questionnaireType}/${sectionId}`
    );
    return data || null;
  } catch {
    return null;
  }
};

export const saveFacilitatorTab = async (tapRequestId, payload) => {
  try {
    const { data } = await http.put(
      `api/tapRequests/${tapRequestId}/facilitatinganalysis`,
      payload
    );
    return data || null;
  } catch {
    return null;
  }
};
export const saveCSEEAnalysis = async (tapRequestId, payload) => {
  try {
    const { data } = await http.put(
      `api/tapRequests/${tapRequestId}/director`,
      payload
    );
    return data || null;
  } catch {
    return null;
  }
};
export const saveCentralLevelAnalysis = async (tapRequestId, payload) => {
  try {
    const { data } = await http.put(
      `api/tapRequests/${tapRequestId}/centrallevel`,
      payload
    );
    return data || null;
  } catch {
    return null;
  }
};
export const saveSAEEAnalysis = async (tapRequestId, payload) => {
  try {
    const { data } = await http.put(
      `api/tapRequests/${tapRequestId}/saeeanalysis`,
      payload
    );
    return data || null;
  } catch {
    return null;
  }
};
export const saveObservation = async (tapRequestId, payload) => {
  try {
    const { data } = await http.post(
      `api/tapRequests/${tapRequestId}/observation`,
      payload
    );
    return data || null;
  } catch {
    return null;
  }
};
export const removeObservation = async (id) => {
  await http.post(
    `api/tapRequests/observation/remove/${id}`,
    {}
  );
};
export const getObservations = async (tapRequestId, tabId) => {
  try {
    const { data } = await http.get(
      `api/tapRequests/${tapRequestId}/observation/${tabId}`
    );
    return data || null;
  } catch {
    return null;
  }
};
